/* Product Page 2026 — variant picker + image gallery + FAQ accordion + sticky buy bar.
 * Loaded by every pp-* section. Idempotent: safe to load multiple times. */
(function () {
  if (window.__pp2026Init) return;
  window.__pp2026Init = true;

  // ─── Variant picker (pp-main) ──────────────────────────────────────────
  function initVariantPicker(root) {
    var form = root.querySelector('#pp-main-form');
    if (!form) return;

    var productId = root.dataset.productId;
    var productData = window.__ppProduct && window.__ppProduct[productId];
    if (!productData) return;

    var inputs = form.querySelectorAll('[data-pp-variant-option]');
    if (!inputs.length) return;

    var variantIdInput = form.querySelector('[data-pp-variant-id]');
    var priceEl = root.querySelector('[data-pp-price]');
    var compareEl = root.querySelector('[data-pp-compare]');
    var saveEl = root.querySelector('[data-pp-save]');
    var atcPriceEl = root.querySelector('[data-pp-atc-price]');
    var atcEl = root.querySelector('[data-pp-atc]');
    var atcLabelEl = root.querySelector('[data-pp-atc-label]');
    var installmentEl = root.querySelector('[data-pp-installment]');
    var inventoryEl = root.querySelector('[data-pp-inventory]');
    var inventoryQtyEl = root.querySelector('[data-pp-inventory-qty]');
    var lowStockThreshold = inventoryEl
      ? parseInt(inventoryEl.dataset.lowStockThreshold || '10', 10)
      : 10;

    function getSelected() {
      var selected = [];
      productData.options.forEach(function (_, i) {
        var input = form.querySelector('[data-pp-variant-option][data-option-position="' + (i + 1) + '"]:checked');
        selected.push(input ? input.value : null);
      });
      return selected;
    }

    function findVariant(selected) {
      return productData.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      var amount = (cents / 100).toFixed(2);
      // Trim .00 → matches money_without_trailing_zeros
      amount = amount.replace(/\.00$/, '');
      return (productData.moneyFormat || '${{amount}}').replace('{{amount}}', amount);
    }

    function recomputeAvailability() {
      var selected = getSelected();
      inputs.forEach(function (input) {
        var pos = parseInt(input.dataset.optionPosition, 10) - 1;
        var probe = selected.slice();
        probe[pos] = input.value;
        var match = productData.variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return probe[i] == null || opt === probe[i];
          });
        });
        var available = !!(match && match.available);
        input.dataset.available = available ? 'true' : 'false';
      });
    }

    function update() {
      var selected = getSelected();
      var variant = findVariant(selected);
      if (!variant) return;

      variantIdInput.value = variant.id;

      // Update URL so refresh / share preserves variant
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Price
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (atcPriceEl) atcPriceEl.textContent = formatMoney(variant.price);
      if (installmentEl) installmentEl.textContent = formatMoney(Math.round(variant.price / 4));

      // Compare-at / Save
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !onSale;
        compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          saveEl.textContent = 'Save ' + pct + '%';
        }
      }

      // ATC availability. A variant that's available but tracked at <= 0 units is
      // only purchasable because "continue selling" is on → it's a pre-order.
      if (atcEl) {
        if (variant.available) {
          atcEl.disabled = false;
          var isPreorder = !!(variant.inventory_management
            && typeof variant.inventory_quantity === 'number'
            && variant.inventory_quantity <= 0);
          var buyLabel = isPreorder
            ? (productData.preorderLabel || 'Pre order')
            : (productData.atcLabel || 'Add to Cart');
          if (atcLabelEl && atcPriceEl) {
            atcLabelEl.innerHTML = buyLabel + ' — <span data-pp-atc-price>' + formatMoney(variant.price) + '</span>';
          } else if (atcLabelEl) {
            atcLabelEl.textContent = buyLabel;
          }
        } else {
          atcEl.disabled = true;
          if (atcLabelEl) atcLabelEl.textContent = 'Sold Out';
        }
      }

      // Inventory message — only for the *current* variant, only if low-stock-and-in-stock
      if (inventoryEl) {
        var showInv = variant.available
          && variant.inventory_management
          && typeof variant.inventory_quantity === 'number'
          && variant.inventory_quantity > 0
          && variant.inventory_quantity <= lowStockThreshold;
        inventoryEl.hidden = !showInv;
        if (showInv && inventoryQtyEl) {
          inventoryQtyEl.textContent = variant.inventory_quantity;
        }
      }

      // Selected variant value display (e.g. "Color: Black") — fade out, swap, fade in
      productData.options.forEach(function (optName, i) {
        var disp = root.querySelector('[data-pp-variant-value="' + optName + '"]');
        if (!disp) return;
        if (disp.textContent === selected[i]) return;
        disp.classList.add('is-swapping');
        setTimeout(function () {
          disp.textContent = selected[i];
          disp.classList.remove('is-swapping');
        }, 140);
      });

      // Swap the gallery to this variant's image — direct and robust (no
      // dependency on a matching thumbnail existing in the strip).
      if (variant.featured_media_id && root.__ppGallery) {
        root.__ppGallery.select(variant.featured_media_id, variant.featured_media_url);
      }

      // Notify sticky buy bar
      document.dispatchEvent(new CustomEvent('pp:variant-change', { detail: { variant: variant, productId: productId } }));

      // Refresh per-option availability based on the new selection
      recomputeAvailability();
    }

    inputs.forEach(function (input) { input.addEventListener('change', update); });

    // Compute availability once on init so JS-rendered state stays in sync
    recomputeAvailability();
  }

  // ─── Image gallery (thumbnail switching) ────────────────────────────────
  // Spinner shows only if load takes > 200ms — cached images don't flash. The
  // previous image stays visible (at 0.4 opacity) until the new one is decoded,
  // so the user always sees content, never a blank box.
  var SPINNER_DELAY_MS = 200;

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-pp-thumb]');
    var imageContainer = root.querySelector('[data-pp-main-image]');
    var main = imageContainer && imageContainer.querySelector('img');
    if (!thumbs.length || !main) return;

    var spinnerTimer = null;
    var loadToken = 0; // guards against out-of-order loads when clicking fast

    function setActive(thumb) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      // Smooth-scroll the active thumb into view (mostly for variant changes)
      if (typeof thumb.scrollIntoView === 'function') {
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    function swapImage(url) {
      if (!url) return;
      // Same image already loaded — no-op
      if (main.currentSrc === url || main.src === url) return;

      var token = ++loadToken;
      imageContainer.classList.add('is-fading');

      clearTimeout(spinnerTimer);
      spinnerTimer = setTimeout(function () {
        // Only show spinner if THIS request is still the latest one in flight
        if (token === loadToken) imageContainer.classList.add('is-loading');
      }, SPINNER_DELAY_MS);

      var preload = new Image();
      var done = function () {
        clearTimeout(spinnerTimer);
        // Discard the result if a newer click superseded this one
        if (token !== loadToken) return;
        if (preload.complete && preload.naturalWidth > 0) {
          main.src = url;
          main.srcset = '';
        }
        imageContainer.classList.remove('is-loading', 'is-fading');
      };
      preload.onload = done;
      preload.onerror = done;
      preload.src = url;
    }

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        swapImage(thumb.dataset.mediaUrl);
        setActive(thumb);
      });

      // Keyboard navigation: Left/Right (and Home/End) cycles thumbs
      thumb.addEventListener('keydown', function (e) {
        var key = e.key;
        var next = null;
        if (key === 'ArrowRight' || key === 'ArrowDown') next = thumbs[idx + 1] || thumbs[0];
        else if (key === 'ArrowLeft' || key === 'ArrowUp') next = thumbs[idx - 1] || thumbs[thumbs.length - 1];
        else if (key === 'Home') next = thumbs[0];
        else if (key === 'End') next = thumbs[thumbs.length - 1];
        if (next) {
          e.preventDefault();
          next.focus();
          next.click();
        }
      });
    });

    function clearActive() { thumbs.forEach(function (t) { t.classList.remove('is-active'); }); }

    // Exposed so the variant picker can drive the gallery directly. Falls back
    // to swapping the main image by URL when the media has no thumbnail.
    root.__ppGallery = {
      select: function (mediaId, url) {
        var thumb = mediaId ? root.querySelector('[data-pp-thumb][data-media-id="' + mediaId + '"]') : null;
        if (thumb) { swapImage(thumb.dataset.mediaUrl || url); setActive(thumb); }
        else if (url) { swapImage(url); clearActive(); }
      }
    };

    // On load, activate the thumbnail for the initially-selected variant.
    var initId = imageContainer.getAttribute('data-featured-media-id');
    if (initId) {
      var initThumb = root.querySelector('[data-pp-thumb][data-media-id="' + initId + '"]');
      if (initThumb) { clearActive(); initThumb.classList.add('is-active'); }
    }
  }

  // ─── FAQ accordion ──────────────────────────────────────────────────────
  function initFaq() {
    document.querySelectorAll('.m-pp-faq__item').forEach(function (item) {
      var q = item.querySelector('.m-pp-faq__q');
      if (!q) return;
      q.addEventListener('click', function () {
        item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      });
    });
  }

  // ─── Sticky buy bar ─────────────────────────────────────────────────────
  function initStickyBuy() {
    var bar = document.querySelector('[data-pp-sticky-buy]');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.showAfter || '900', 10);
    var visible = false;
    function check() {
      var should = window.scrollY > threshold;
      if (should !== visible) {
        bar.classList.toggle('is-visible', should);
        visible = should;
      }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  // ─── Init on load ───────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('.m-pp-main').forEach(function (root) {
      initVariantPicker(root);
      initGallery(root);
    });
    initFaq();
    initStickyBuy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── ScrollTrigger position hardening (product pages) ────────────────────────
   Same layer as th-series.js (which product templates do not load): long pages
   keep growing after reveal triggers are created — lazy images, videos,
   carousels — leaving once:true starts far below the sections they guard, so
   content sits hidden long after it is on screen. Re-sync positions (debounced,
   only when the document height actually moved) whenever late layout lands. */
(function () {
  if (window.__ppStHarden) return;
  window.__ppStHarden = true;
  var pending = null;
  var lastH = 0;
  function refresh() {
    pending = null;
    if (!window.ScrollTrigger) return;
    var h = document.documentElement.scrollHeight;
    if (Math.abs(h - lastH) < 4) return;
    lastH = h;
    window.ScrollTrigger.refresh();
  }
  function queue() {
    if (pending) return;
    pending = setTimeout(refresh, 250);
  }
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && (t.tagName === 'IMG' || t.tagName === 'VIDEO')) queue();
  }, true);
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(queue);
  }
  function watchBody() {
    lastH = document.documentElement.scrollHeight;
    if ('ResizeObserver' in window && document.body) {
      new ResizeObserver(queue).observe(document.body);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchBody, { once: true });
  } else {
    watchBody();
  }
  window.addEventListener('load', queue);
})();

/* ── Reveal-fire guard ────────────────────────────────────────────────────────
   Long pages mutate layout constantly (lazy media, tabs, carousels, third-party
   widgets), and a ScrollTrigger position captured during a transient collapse
   can leave once:true reveals firing thousands of px before their element is
   on screen ("everything already visible"). Positions can lie; live geometry
   cannot: wrap ScrollTrigger.create/batch so a once-reveal that fires while
   its element is still far below the fold is swallowed and re-armed with an
   IntersectionObserver, which fires at TRUE viewport entry. */
(function () {
  function wrap(ST) {
    if (ST.__epoGuard) return;
    ST.__epoGuard = true;
    function farBelow(node) {
      if (!node || !node.getBoundingClientRect) return false;
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      return node.getBoundingClientRect().top > vh * 1.15;
    }
    function rearm(node, fire) {
      /* Live-geometry re-arm. Not an IntersectionObserver: an instant jump
         (jump-nav, anchor) can move the element from below to above the
         viewport between frames, and IO never observes an intersection.
         top < 95% viewport covers both entering AND already-passed. */
      var done = false, ticking = false;
      function check() {
        if (done) return;
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        if (node.getBoundingClientRect().top < vh * 0.95) {
          done = true;
          window.removeEventListener('scroll', onScroll);
          fire();
        }
      }
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; check(); });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      check();
    }
    var origCreate = ST.create;
    ST.create = function (vars) {
      if (vars && vars.once && typeof vars.onEnter === 'function' && vars.trigger && !vars.scrub && !vars.pin) {
        var onEnter = vars.onEnter;
        vars.onEnter = function (self) {
          var node = self && self.trigger;
          if (farBelow(node)) {
            var st = this;
            rearm(node, function () { onEnter.call(st, self); });
            if (self && self.kill) self.kill();
            return;
          }
          return onEnter.apply(this, arguments);
        };
      }
      return origCreate.call(this, vars);
    };
    var origBatch = ST.batch;
    ST.batch = function (targets, vars) {
      if (vars && vars.once && typeof vars.onEnter === 'function') {
        var onEnter = vars.onEnter;
        vars.onEnter = function (elements, triggers) {
          var near = [], ctx = this;
          (elements || []).forEach(function (el) {
            if (farBelow(el)) rearm(el, function () { onEnter.call(ctx, [el], triggers); });
            else near.push(el);
          });
          if (near.length) return onEnter.call(ctx, near, triggers);
        };
      }
      return origBatch.call(this, targets, vars);
    };
  }
  /* Wrap the instant the library lands — a timer poll can lose the race
     against section scripts that build on the DOMContentLoaded microtask. */
  if (window.ScrollTrigger) { wrap(window.ScrollTrigger); }
  else {
    try {
      var _st;
      Object.defineProperty(window, 'ScrollTrigger', {
        configurable: true, enumerable: true,
        get: function () { return _st; },
        set: function (v) { _st = v; if (v && v.create) { try { wrap(v); } catch (e) {} } }
      });
    } catch (e) {
      (function poll(n) {
        if (window.ScrollTrigger) return wrap(window.ScrollTrigger);
        if (n <= 0) return;
        setTimeout(function () { poll(n - 1); }, 25);
      })(400);
    }
  }
})();
